import React from 'react';
import { Route } from 'react-router-dom';
import { ConnectedRouter } from 'react-router-redux';
import history from '../history';
import VendorPage from '../components/HomePage';
import SignPage from '../components/SignPage';
import KeyFieldPage from '../components/KeyFieldPage';
import KeyFormPage from '../components/KeyFormPage';

const HomePage = () => <div>Home</div>;

const Routes = () => (
  <ConnectedRouter history={history}>
    <div>
      <Route exact path="/" component={HomePage} />
      <Route path="/vendor/:vendorId" component={VendorPage} />
      <Route path="/sign/:vendorId/:signId" component={SignPage} />
      <Route path="/development/keyfield" component={KeyFieldPage} />
      <Route path="/development/keyform" component={KeyFormPage} />
    </div>
  </ConnectedRouter>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/routes/index.js